//@ts-ignore
import { ErrorBoundary, Provider } from '@rollbar/react'
import { App } from 'application/App'
import { AppConfig } from 'application/configuration'
import { AppConfigProvider } from 'application/configuration'
import { CorvetteTheme, ThemeProvider } from 'application/theme'
import { GolfTheme } from 'application/theme'
import { FC, StrictMode } from 'react'
import Rollbar from 'rollbar'

import { StageError } from '../ui/stage-error'

const rollbarConfig = {
  accessToken: '85a6c8c8cb504bd1863ba05dcafca4ba',
  captureUncaught: false,
  captureUnhandledRejections: false
}

export type Props = {
  golfTheme?: GolfTheme
  corvetteTheme?: CorvetteTheme
  config: AppConfig
}

export const Root: FC<Props> = ({ config, golfTheme, corvetteTheme }) => {
  return (
    <StrictMode>
      <AppConfigProvider value={config}>
        <ThemeProvider golfTheme={golfTheme} corvetteTheme={corvetteTheme}>
          <Provider config={rollbarConfig}>
            <ErrorBoundary fallback={<StageError>Unhandled exception</StageError>}>
              <App />
            </ErrorBoundary>
          </Provider>
        </ThemeProvider>
      </AppConfigProvider>
    </StrictMode>
  )
}
